import { Component, HostListener, ChangeDetectionStrategy, ChangeDetectorRef, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { AppService } from './modules/shared/app-service/app-service.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'aqualia-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {

  isMobile: boolean = true;

  private subscription: Subscription = new Subscription();

  constructor(translate: TranslateService, public appService: AppService, public cd: ChangeDetectorRef) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('es');

    let userInfo = JSON.parse(localStorage.getItem(environment.userStorage));
    if (userInfo != null && userInfo[0].cod_Idioma != null) {
      translate.use(userInfo[0].cod_Idioma);
    }

    this.checkDevice();

    this.subscription.add(this.appService.detectChangesAppStream.subscribe(() => {
      this.cd.markForCheck();
    }));
  }

  checkDevice() {
    if (window.innerWidth < 860) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 860) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    this.cd.detectChanges();
  }

  isLogged() {
    if (!this.appService.isLogged) {
      this.appService.checkLogged();
    }
    return this.appService.isLogged;
  }

  isLoggedOrLogin() {
    if (!this.appService.isLogged) {
      this.appService.checkLogged();
    }
    return this.appService.isLogged || this.appService.actualUrl == '/login';
  }

}
